import PropTypes from 'prop-types';
import React from 'react';

import Authorization from '@appComponents/Authorization';
import {ButtonAdd} from '@appComponents/ButtonCollection';
import Link from '@appComponents/Link';
import {WATERMARKING} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE_READ} from '@constants/variables';

const authorizationObject = {
    [WATERMARKING]: SECURITY_PRIVILEGES_CREATE_READ,
};

const EventWatermarkingButtons = ({eventId}) => (
    <div className='content__buttons'>
        <Authorization authorization={authorizationObject}>
            <Link name='events.watermarking.add' params={{id: eventId}}>
                <ButtonAdd>Add new watermarking configuration</ButtonAdd>
            </Link>
        </Authorization>
    </div>
);

EventWatermarkingButtons.propTypes = {
    eventId: PropTypes.number,
};

export default EventWatermarkingButtons;
